import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=61561a40"
import script from "./textarea.vue?vue&type=script&lang=ts"
export * from "./textarea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports